import {
  GetUsageStatisticsRequest,
  GetUsageStatisticsRequestToJSON,
  HTTPBody,
  HTTPQuery,
  RegisterUsageStatisticsRequest,
  RegisterUsageStatisticsRequestToJSON,
  UsageStatistics,
  UsageStatisticsFromJSON
} from '@/api'
import * as runtime from '../runtime'

export class UsageStatisticsApi extends runtime.BaseAPI {
  /**
   * 利用統計を取得する
   * 利用統計取得
   */
  async getUsageStatistics(
    request: GetUsageStatisticsRequest
  ): Promise<UsageStatistics> {
    const queryParameters: HTTPQuery = Object.fromEntries(
      Object.entries(GetUsageStatisticsRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet('/usage-statistics', queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      UsageStatisticsFromJSON(jsonValue)
    ).value()
  }

  /**
   * 利用統計を登録する
   * 利用統計登録
   */
  async registerUsageStatistics(
    request: RegisterUsageStatisticsRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = RegisterUsageStatisticsRequestToJSON(
      request
    )

    const response = await this.requestPost('/usage-statistics', bodyParameters)

    return new runtime.VoidApiResponse(response)
  }
}
